import React from "react";
import { useNavigate } from "react-router-dom";

const Post = () => {
  const navigate=useNavigate();
  return (
    <div className="post-container">
      <div className="post-heading">
        <span>Our Recent Posts</span>
      </div>
      <div className="recent-post-container">
        <div>
          <div className="post-image"></div>
        </div>
        <div>
          <div className="post-text">
            <span>DEVELOPMENT</span>
            <span>16 March 2025</span>
          </div>
          <div className="post-details">
            <span>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod
            </span>
            <span>
              Google has been investing in AI for many years and bringing its
              benefits to individuals, businesses and communities. Whether it’s
              publishing state-of-the-art research, building helpful products or
              developing...
            </span>
            <button onClick={()=>{navigate('/blogPage')}}>Read More</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Post;
